// decision-auto-secret-key-name-tokens.ts — Codex F8 (spec V2 §4.1 điều 3).
//
// Tên key của nguồn secrets là token ranh giới buộc hỏi người:
//  - `test.env` của mission — nạp lại MỖI lần gọi; chỉ loader `ok` mới đăng ký
//    tên key (mission-secrets-test-env-loader.ts);
//  - map stdin release của process (`run --release-secrets-stdin`, đăng ký ở
//    `addStdinValues`).
// Trả HỢP mọi key đã thấy trong process (registry chỉ thêm) ⇒ file bị xoá giữa
// run không làm mất token. `test.env` tồn tại mà không kiểm chứng được
// (quyền/owner/symlink/quá lớn/không đọc được) ⇒ `problem` ⇒ caller về `ask`.
import type { BoundaryTokensRead } from "./decision-auto-boundary-tokens.js";
import { registeredSecretKeyNames } from "./mission-known-secret-values-registry.js";
import { loadMissionTestEnv } from "./mission-secrets-test-env-loader.js";

export async function readSecretKeyNameTokens(
  missionId: string | undefined,
): Promise<BoundaryTokensRead> {
  if (missionId === undefined) return { ok: true, tokens: [] };
  try {
    const loaded = await loadMissionTestEnv(missionId);
    if (loaded.status === "invalid_permissions" || loaded.status === "unreadable") {
      return {
        ok: false,
        problem: `test.env của mission không kiểm chứng được (${loaded.status})`,
      };
    }
  } catch {
    return { ok: false, problem: "test.env của mission không kiểm chứng được (lỗi đọc)" };
  }
  return { ok: true, tokens: registeredSecretKeyNames(missionId) };
}
